import React from "react";

export const OrangeAlert = (props) => {
  return (
    <div className="fgaAlert orangeAlert">
      <div className="alertIcon">
        <span className="iconmford fo-icon-info-outline"></span>
      </div>
      <div className="alertText">{props.content}</div>
    </div>
  );
};
